import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';
import { environment } from 'src/environments/environment';


@Component({
	selector: 'ras-faqs-page',
	templateUrl: './faqs-page.component.html',
	styleUrls: ['./faqs-page.component.sass']
})
export class FaqsPageComponent implements OnInit {
	public environment = environment;

	constructor(private meta: MetaService) { }

	ngOnInit() {
		this.meta.apply('faqs')
	}

}
